module.exports = __webpack_public_path__ + "static/hypermobility-5d4a83600c812b926477f122f07aa31d.jpg";